// extracted by mini-css-extract-plugin
module.exports = {"accordionContainer":"_d82923","avatars":"_c8d30d","accordionTitle":"_93338e","accordionSummary":"_7a2e30","root":"_9b79f0","snippetContainer":"_79fb94","snippet":"_c83352"};